import React from 'react';
import { Alert, AlertTitle, Stack, Typography } from '@mui/material';
import type { Info360Alerta, Info360Recomendacion, Info360Severidad } from '../types';

interface Props {
  recomendacion: Info360Recomendacion;
  alertas: Info360Alerta[];
}

const toMuiSeverity = (s: Info360Severidad): 'success' | 'warning' | 'error' | 'info' => {
  if (s === 'ok') return 'success';
  if (s === 'danger') return 'error';
  if (s === 'warning') return 'warning';
  return 'info';
};

const Info360Recommendation: React.FC<Props> = ({ recomendacion, alertas }) => {
  const alertasVisibles = alertas.filter((a) => a.codigo !== 'SIN_ALERTAS').slice(0, 3);
  const sinAlertas = alertasVisibles.length === 0;

  return (
    <Stack spacing={1.5}>
      <Alert severity={toMuiSeverity(recomendacion.severidad)} variant="outlined">
        <AlertTitle sx={{ fontWeight: 700 }}>{recomendacion.titulo}</AlertTitle>
        <Typography variant="body2">{recomendacion.detalle}</Typography>
      </Alert>

      {sinAlertas ? (
        <Alert severity="success" variant="standard">
          Sin alertas relevantes en los indicadores actuales.
        </Alert>
      ) : (
        <Stack spacing={1}>
          {alertasVisibles.map((alerta) => (
            <Alert key={alerta.codigo} severity={toMuiSeverity(alerta.severidad)} variant="standard">
              <AlertTitle sx={{ mb: 0.25 }}>{alerta.titulo}</AlertTitle>
              <Typography variant="body2">{alerta.detalle}</Typography>
            </Alert>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default Info360Recommendation;
